/* src/app/app.footer.component.scss */
.beta-notification {
  font-size: smaller;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.admin-footer-message {
  font-size: smaller;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.admin-footer-link {
  font-size: smaller;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.version-footer {
  font-size: xx-small;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  color: lightgray;
  padding-left: 1em;
}
/*# sourceMappingURL=app.footer.component.css.map */
